import { createContext } from "react";

// The ProfileBailleur id the surrounding subtree concerns (null = unscoped).
export const PermissionScopeContext = createContext<number | null>(null);
